/**
 * Styles used by Giphy Component to change the size of the Giphy SearchBox
 */
export const giphyStyles = {
    paddingTop: '25px',
    '.searchBox': {
      height: '60px',
    },
  
    '.customToolbar': {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      width: '100%',
    },
  };
  